import React, { useState } from 'react';
import ThreeWayRecon from './ThreeWayRecon';
import Aeps from './Aeps';
import CreditTxn from './CreditTxn';
import './MainMatm.css';

export default function MatmMain() {
  const [activeTab, setActiveTab] = useState('three-way');

  return (
    <div className="a1b2c3_la-app-wrapper">
      <div className="a1b2c3_la-shell-container">
        <div className="a1b2c3_la-shell-header">
          <h1 className="a1b2c3_la-main-title">MATM</h1>
        </div>      
        <div className="a1b2c3_la-navigation-bar">
          <div className="a1b2c3_la-tabs-pill-container">
            <button
              className={`a1b2c3_la-nav-link ${activeTab === 'three-way' ? 'a1b2c3_is-active' : ''}`}
              onClick={() => setActiveTab('three-way')}
            >
              Three Way Recon
            </button>
            <button
              className={`a1b2c3_la-nav-link ${activeTab === 'aeps' ? 'a1b2c3_is-active' : ''}`}
              onClick={() => setActiveTab('aeps')}
            >
              AEPS
            </button>
            <button
              className={`a1b2c3_la-nav-link ${activeTab === 'credit' ? 'a1b2c3_is-active' : ''}`}
              onClick={() => setActiveTab('credit')}
            >
             
              Credit Transaction
            </button>
          </div>
        </div>

       
        <div className="a1b2c3_la-view-viewport">
          <div className="a1b2c3_la-view-transition-wrapper">
            {activeTab === 'three-way' && <ThreeWayRecon />}
            {activeTab === 'aeps' && <Aeps />}
            {activeTab === 'credit' && <CreditTxn />}
          </div>
        </div>

      </div>
    </div>
  );
}